<ion-grid *ngIf="patient">
	<ng-container *ngFor="let prop of getDisplayedProperties(patient, excludes); let i = index">
		<div class="patient-details">
			<div class="patient-details__icon">
				<fa-icon [icon]="prop.icon" [fixedWidth]="true" size="sm"></fa-icon>
			</div>
			<div class="patient-details__label" [attr.data-testid]="'patient_details__label_' + i">{{ prop.label }}</div>
			<div>
				<ng-container *ngFor="let value of prop.getValues(patient); let j = index">
					<div class="patient-details__value" [attr.data-testid]="'patient_details__value_' + i + '_' + j">{{ value }}</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</ion-grid>
